module.exports = __webpack_public_path__ + "8552bf2dbdc9882f943e041206494928.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/boots-high-heels.png
// module id = 1882
// module chunks = 0